import styled from 'styled-components'

import { FontPreset, FontStyle, TFontStyleMixin } from '../styles/mixins'
import { Text } from './Text'

export const ParagraphOpenSans = styled(Text)<TFontStyleMixin>`
  ${FontPreset('paragraph opensans')};
  ${(props: TFontStyleMixin) =>
    FontStyle({
      ...props,
    })}
`
